export var source_tools = { "uid": "source_tools", "fields": { "title": { "defaultValue": "" } } };
